import api from '../../service/modules/refund';

export default {
  namespaced: true,
  state: {
    cachedViews: [],
    statusType: '', // 退货列表筛选状态
    statisticalAnalysisTime: {
      startTime: '',
      endTime: ''
    }, // 统计分析筛选时间
    statisticalAnalysisReginCode: '',
    tempFiles: [],
    detail: '', // 退货单详情，包含所有
    mobile: '13590257630',
    userInfo: '',
    startTime: '',
    endTime: '',
    flowId: '',
    configlist: '',
    LOADING: false,
    regionList: [], // 省市县列表
    regionWithSelfList: null,
    retreatRequest: {
      // 出行方式
      items: [
        { itemName: '', productTypes: '', num: '', amount: '', commodity: {} }
      ],
      // goodsName: '', // 商品名称
      // goodsType: '', // 商品类型
      // goodsNum: '', // 商品数量
      // shoppingAmount: '', // 购物金额
      pcityId: '', // 城市
      areaId: '', // 区县
      shoppingStore: '', // 企业名称
      storeId: '', // 企业ID
      shoppingAddress: '', // 企业地址
      storeTel: '', // 企业电话
      isSelf: '1', // 是否本人退货
      purchaser: '', // 购买人
      paperwork: '', // 证件号码
      telephone: '', // 联系电话
      submit_user: '', // 退货人
      submit_user_id_card: '', // 退货人证件号码
      submit_user_tel: '', // 退货人联系电话
      refundReason: '', // 退货原因
      refundChannel: 3, // 退货方式
      refundType: 2,
      purchaseChannel: 2, // 购买方式
      refundContent: '', // 退货情况描述说明
      // idType: '', // 证件类型
      shoppingTime: '', // 购物时间
      sex: '', // 购买人性别
      cityId: '', // 532530
      shoppingCityId: '', // 购物地 532530
      // refundAppeal:'', // 退货诉求

      travelName: '', // 旅行社
      lineName: '', // 线路名称
      travelTime: '', // 出团时间
      itineraryNo: '', // 行程单号

      attach: '', // 退货单附件
      infoAttach: [], // 退货单附件
      fileList: [],
      reasonsForReturn: {}, // 选择的退货原因
      wayBuying: {
        name: '⾃⼰出行购买',
        id: 2
      }, // 选择跟团行程单
      returnMethod: {
        name: '现场退货',
        id: 2
      }, // 退货方式
      fieldValue: '',
      regionList: [],

      companyList: [] // 有退货处置权限企业列表
    },
    resetRequest: {
      // 出行方式
      items: [
        { itemName: '', productTypes: '', num: '', amount: '', commodity: {} }
      ],
      // goodsName: '', // 商品名称
      // goodsType: '', // 商品类型
      // goodsNum: '', // 商品数量
      // shoppingAmount: '', // 购物金额
      pcityId: '', // 城市
      areaId: '', // 区县
      shoppingStore: '', // 企业名称
      storeId: '', // 企业ID
      shoppingAddress: '', // 企业地址
      storeTel: '', // 企业电话
      isSelf: '1', // 是否本人退货
      purchaser: '', // 购买人
      paperwork: '', // 证件号码
      telephone: '', // 联系电话
      submit_user: '', // 退货人
      submit_user_id_card: '', // 退货人证件号码
      submit_user_tel: '', // 退货人联系电话
      refundReason: '', // 退货原因
      refundChannel: 3, // 退货方式
      refundType: 2,
      purchaseChannel: 2, // 购买方式
      refundContent: '', // 退货情况描述说明
      // idType: '', // 证件类型
      shoppingTime: '', // 购物时间
      sex: '', // 购买人性别
      cityId: '', // 532530
      shoppingCityId: '', // 购物地 532530
      // refundAppeal:'', // 退货诉求

      travelName: '', // 旅行社
      lineName: '', // 线路名称
      travelTime: '', // 出团时间
      itineraryNo: '', // 行程单号

      attach: '', // 退货单附件
      infoAttach: [], // 退货单附件
      fileList: [],
      reasonsForReturn: {}, // 选择的退货原因
      wayBuying: {
        name: '⾃⼰出行购买'
      }, // 选择跟团行程单
      returnMethod: {
        name: '现场退货',
        id: 2
      }, // 退货方式
      fieldValue: '',
      regionList: []
    },
    dictType: null,
    currentUser: null,
  },
  getters: {
    getCompanyList (state) {
      return state.companyList;
    },
    getRegionList (state) {
      return state.regionList;
    },
    getRegionCode (state) {
      return state.userInfo.regionCode
    },
    getRegionType (state) {
      return state.currentUser.regionType
    },
    getRegionWithSelfList (state) {
      return state.regionWithSelfList;
    },
    getRetreatRequest (state) {
      return state.retreatRequest;
    },
    getDictType (state) {
      return state.dictType;
    },
    getResetRequest (state) {
      return state.resetRequest;
    },
    getCurrentUser (state) {
      return state.currentUser;
    },
    isRegulatoryUser (state) {
      if (!state.currentUser) return false;
      // const regulatoryUser = ["SuperAdmin", "Handler", "Leader"];
      const regulatoryUser = ['Handler'];
      const isRegulatoryUser = state.currentUser.roleList.reduce(
        (pre, next) => pre || !!regulatoryUser.find((user) => next === user),
        false
      );
      // const isRegulatoryUser = (state.currentUser.regionType !== '3') // 3为区县级，只能看区县，否则可以看州市和区县，为两列
      return isRegulatoryUser;
    }
  },
  mutations: {
    ADD_CACHED_VIEW: (state, view) => {
      if (state.cachedViews.includes(view.name)) {
        return
      }
      state.cachedViews.push(view.name)
    },
  // 移除缓存
    DEL_CACHED_VIEW: (state, view) => {
      const index = state.cachedViews.indexOf(view.name)
      index > -1 && state.cachedViews.splice(index, 1)
      console.log('vuex数组', state.cachedViews);
      
    },

    // 添加上传成功图片
    addTempFiles: (state, data) => {
      state.tempFiles.push(data)
    },
    // 删除预览图片
    delTempFiles: (state, data) => {
      for (let i = 0; i < state.tempFiles.length; i++) {
        if (state.tempFiles[i].fileName === data.fileName) {
          state.tempFiles.splice(i, 1)
          break
        }
      }
    },
    companyListMutation (state, data) {
      state.companyList = data;
    },
    getUserInfo: (state, data) => {
      // 用户信息
      state.userInfo = data;
      localStorage.setItem('refundUserInfo', JSON.stringify(data));
    },
    getStartTime: (state, data) => {
      // 开始时间
      state.startTime = data;
      localStorage.setItem('startTime', data);
    },
    getEndTime: (state, data) => {
      // 结束时间
      state.endTime = data;
      localStorage.setItem('endTime', data);
    },
    setFlowId: (state, data) => {
      // 单号
      state.flowId = data;
    },
    setConfiglist: (state, data) => {
      // 基础信息配置数据
      state.configlist = data;
    },
    showLoading (state, data) {
      state.LOADING = data;
    },
    inRegionList: (state, data) => {
      state.regionList = data;
    },
    inRegionWithSelfList: (state, data) => {
      state.regionWithSelfList = data;
    },
    inRetreatRequest: (state, data) => {
      state.retreatRequest = data;
    },
    inDictType: (state, data) => {
      state.dictType = data;
    },
    inCurrentUser: (state, data) => {
      state.currentUser = data;
    }
    // hideLoading (state) {
    //     state.LOADING = false
    // }
  },
  actions: {
    // 获取有处置权限的企业列表
    setCompanyList: (context, data) => {
      return new Promise((resolve, reject) => {
        api
          .getDisposeEnterprise(data)
          .then((res) => {
            if (res.ret == 0) {
              context.commit('companyListMutation', res.data);
            }
            resolve(res.data);
          })
          .catch((err) => {
            reject(err.data);
          });
      });
    },
    setLoading: (context, data) => {
      context.commit('showLoading', data);
    },
    setRegionList: (context, data) => {
      // if (context.state.regionList.length) {
      //   return Promise.resolve(context.state.regionList);
      // }
      return new Promise((resolve, reject) => {
        api
          .getRegion(data)
          .then((res) => {
            if (res.ret == 0) {
              context.commit('inRegionList', res.data);
            }
            resolve(res.data);
          })
          .catch((res) => {
            reject(res.data);
          });
      });
    },
    setRegionWithSelfList: (context, data) => {
      if (context.state.regionWithSelfList.length) {
        return Promise.resolve(context.state.regionWithSelfList);
      }
      return new Promise((resolve, reject) => {
        api
          .regionWithSelf(data)
          .then((res) => {
            if (res.ret == 0) {
              context.commit('inRegionWithSelfList', res.data);
            }
            resolve(res.data);
          })
          .catch((res) => {
            reject(res.data);
          });
      });
    },
    setCurrentUser: (context, data) => {
      // if (context.state.currentUser) {
      //   return Promise.resolve(context.state.currentUser);
      // }
      return new Promise((resolve, reject) => {
        api
          .currentUser(data)
          .then((res) => {
            if (res.ret == 0) {
              context.commit('inCurrentUser', res.data);
            }
            resolve(res.data);
          })
          .catch((res) => {
            reject(res.data);
          });
      });
    },
    setRetreatRequest: (context, data) => {
      context.commit('inRetreatRequest', data);
    },

    setDictType: (context, data) => {
      if (context.state.dictType) {
        return Promise.resolve(context.state.dictType);
      }
      return new Promise((resolve, reject) => {
        api
          .getDictType(data)
          .then((res) => {
            if (res.ret == 0) {
              context.commit('inDictType', res.data);
            }
            resolve(res.data);
          })
          .catch((res) => {
            reject(res.data);
          });
      });
    },
    backendFileUpload: (context, data) => {
      return new Promise((resolve, reject) => {
        api
          .backendFileUpload(data)
          .then((res) => {
            resolve(res.data[0]);
          })
          .catch((res) => {
            reject(res.data);
          });
      });
    },
    getQueryEnterpriseList: (context, data) => {
      return new Promise((resolve, reject) => {
        api
          .getQueryEnterpriseList(data)
          .then((res) => {
            resolve(res.data);
          })
          .catch((res) => {
            reject(res.data);
          });
      });
    },
    postCreateRefund: (context, data) => {
      return new Promise((resolve, reject) => {
        api
          .postCreateRefund(data)
          .then((res) => {
            if (res.ret === 0) {
              resolve(res.data);
            } else {
              reject(res.msg);
            }
          })
          .catch((res) => {
            reject(res.msg);
          });
      });
    },
    getItineraryListByIdCard: (context, data) => {
      return new Promise((resolve, reject) => {
        api
          .getItineraryListByIdCard(data)
          .then((res) => {
            resolve(res.data);
          })
          .catch((res) => {
            reject(res.data);
          });
      });
    }
  }
};
